<template>
    <LrudNode class="wrapper">
        <Aside />
        <slot />
    </LrudNode>
</template>
